import { useLocalizable } from '@contexts/LocalizableContext'
import { Lang } from '@models/Lang'
import { Localizable } from '@models/Localizable'
import { Fragment, ReactNode } from 'react'
import { langList } from '../../factories/Utils'

interface Props<T = any> {
  item: Localizable<T>
  render: (localizedItem: T, lang: Lang) => ReactNode
}

export const Render = <T,>({ item, render }: Props<T>) => {
  const localizable = useLocalizable()

  if (localizable) {
    const { langCode } = localizable
    return (
      <>
        {item &&
          item.hasOwnProperty(langCode) &&
          render(
            item[langCode as keyof Localizable<T>],
            langList.find((lang) => lang.code === langCode) ?? langList[0]
          )}
      </>
    )
  }

  return langList.map((lang) => (
    <Fragment key={lang.id}>
      {item &&
        item.hasOwnProperty(lang.code) &&
        render(item[lang.code as keyof Localizable<T>], lang)}
    </Fragment>
  ))
}

export type RenderType = { Render: typeof Render }
